import React from "react";
import { LogOutIcon } from "lucide-react";

import { useNavigate } from "react-router-dom";
import { useToken } from "lib/utils/useToken";

import { useAuth } from "lib/utils/useAuth";

export const Header = () => {
  const navigate = useNavigate();
  const { removeToken } = useToken();
  const { removeAuth } = useAuth();

  const handleLogout = () => {
    removeToken();
    removeAuth();
    navigate("/login");
    window.location.reload();
  };

  return (
    <div className="header">
      <div className="d-flex align-items-center header_right">
        <div style={{ width: "auto", minWidth: "unset" }}>
          <button
            onClick={handleLogout}
            title="Log out"
            aria-label="Log out"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              padding: "6px 10px",
              backgroundColor: "#FDECEA",
              color: "#D93025",
              border: "1px solid #F5C2C7",
              borderRadius: "6px",
              cursor: "pointer",
              lineHeight: 1,
            }}
          >
            <LogOutIcon size={16} />
            <span style={{ fontSize: "0.875rem", fontWeight: 500 }}>Log out</span>
          </button>
        </div>
      </div>
    </div>
  );
};
